import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { SvgIcon } from '@material-ui/core/'
import { mdiAccountOff } from '@mdi/js'

import * as DoorAccessActionCreators from '../../actions/doorAccess'
import Pluralize from '../controls/Pluralize'
import TooltipIconButton from '../controls/TooltipIconButton'

class DisableUsersButtonContainer extends React.Component {
  static propTypes = {
    /* passed props */
    accessIds: PropTypes.array.isRequired,
    communityId: PropTypes.number.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static mapStateToProps() {
    return {}
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  handleDisable = () => {
    this.props.doorAccessActions.disableDoorAccesses(this.props.communityId, this.props.accessIds)
  }

  render() {
    const userCount = this.props.accessIds.length
    const tooltipTitle = (
      <span>
        Disable <Pluralize count={userCount} showCount={userCount > 1} singular="User" />
      </span>
    )

    return (
      <TooltipIconButton
        color="primary"
        onClick={this.handleDisable}
        tooltipTitle={tooltipTitle}
      >
        <SvgIcon>
          <path d={mdiAccountOff} />
        </SvgIcon>
      </TooltipIconButton>
    )
  }
}

export default connect(
  DisableUsersButtonContainer.mapStateToProps,
  DisableUsersButtonContainer.mapDispatchToProps,
)(DisableUsersButtonContainer)
